import { ScreenplayEntity } from '@/shared/lib/db'
import { screenplayLocalRepository } from '../repositories/screenplay.local.repository'
import { ScreenplayRepository } from '../repositories/screenplay.repository'

export class ScreenplayService {
    constructor(private repository: ScreenplayRepository) {}

    async get(id: string): Promise<ScreenplayEntity | undefined> {
        return this.repository.get(id)
    }

    async getAll(projectId: string): Promise<ScreenplayEntity[]> {
        return this.repository.getAllByProject(projectId)
    }

    async save(screenplay: ScreenplayEntity): Promise<void> {
        return this.repository.save(screenplay)
    }

    async delete(id: string, projectId: string): Promise<void> {
        return this.repository.delete(id, projectId)
    }

    async getByTitle(projectId: string, title: string): Promise<ScreenplayEntity | undefined> {
        return this.repository.getByTitle(projectId, title)
    }
}

export const screenplayService = new ScreenplayService(screenplayLocalRepository)
